<template>
  <div v-if="!loading">
    <div class="pl-0 pr-0 diaryWrite">
      <v-text-field 
        class="diaryWriteTitle" 
        placeholder="제목을 입력하세요." 
        v-model="title"
        hide-details="true"
        maxlength="25"
      ></v-text-field>
      <v-slider 
        class="diaryWriteDesire"
        label="흡연욕구" 
        v-model="desire" 
        max="10" 
        min="0"
        thumb-size="0"
        track-color="#ccc"
        hide-details
      ></v-slider>
      <v-textarea 
        class="diaryWriteText"
        placeholder="내용을 입력하세요." 
        v-model="text"
        maxlength="300"
      ></v-textarea>
    </div>
    <div
      class="customButtonBox2"
      v-show="!loading"
    >
      <div 
        class="customButton2 gray" 
        @click="$router.go(-1)"
      >취소</div>
      <div 
        class="customButton2" 
        @click="submitDiary"
      >작성</div>
    </div>
    <span 
      v-if="alert"
      class="alert"
    >
      <v-icon class="alertIcon">mdi-alert</v-icon>
      {{ alertMessage }}
    </span>
  </div>
</template>
<script>
export default {
  name: "DiaryWrite",
  data() {
    return {
      loading: true,
      title: undefined,
      text: undefined,
      parsedText: undefined,
      desire: 5,
      alert: false,
      alertMessage: undefined,
    };
  },
  computed: {
    challengeId() {
      return this.$store.getters.challengeId;
    },
    date() {
      return this.$route.query.date;
    },
  },
  methods: {
    replaceAll(str, searchStr, replaceStr) {
      return str.split(searchStr).join(replaceStr);
    },
    submitDiary() {
      this.loading = true;

      if(!this.title == undefined || !this.title){
        this.alert = true;
        this.loading = false;
        this.alertMessage = '제목을 입력해주세요.';
        return false;
      } else if(!this.text == undefined || !this.text){
        this.alert = true;
        this.loading = false;
        this.alertMessage = '내용을 입력해주세요.';
        return false;
      }else{
        this.parsedText =
        "<p>" + this.replaceAll(this.text, "\n", "</p><p>") + "</p>";

        // this.$axios
        // .post("/challenges/" + this.challengeId + "/diaries", {
        //   date: this.date,
        //   title: this.title,
        //   text: this.parsedText,
        //   desire: this.desire,
        // })
        // .then((response) => {
        //   this.$router.push("/diary/detail?id=" + response.data);
        //   this.loading = false;
        // });
        this.$router.push("/diary/detail");
        this.loading = false;
      }
    },
  },
  mounted() {
    // this.$axios
    //   .get("/challenges/" + this.challengeId + "/diaries?date=" + this.date)
    //   .then((response) => {
    //     this.loading = false;

    //     if (
    //       !(
    //         !response.data ||
    //         response.data.length == 0 ||
    //         response.data[0].is_passed === false
    //       )
    //     ) {
    //       this.$router.push("/calendar");
    //     }
    //   });
    this.loading = false;
  },
};
</script>
<style lang="scss">
.diaryWrite{
  *{
    color: #555 !important;
    font-size: 32px;
    font-weight: bold;
    font-family: UhBee-mysen, 'Fighting_hyonam';
  }

  .diaryWriteTitle{
    &.v-text-field{
      padding: 0;
      margin: 0;

      input{
        padding: 0;
      }
    }
    &.v-input--hide-details > .v-input__control > .v-input__slot{
      padding: 40px 20px 8px;
      margin-top: 0;
      background-color: #f2f2f2;

      input{

        &::placeholder{
          color: #555;
        }
      }
    }
    &.v-text-field > .v-input__control > .v-input__slot:before{
      border-color: #ccc;
    }
  }
  .diaryWriteDesire{
    padding: 8px 20px;
    border-bottom: 1px solid #ccc;

    .v-slider{
      border-radius: 40px;

    }
    .v-slider--horizontal .v-slider__track-container{
      height: 20px;
    }
    .v-slider__thumb{
      width: 20px;
      height: 20px;
      left: -9px;
    }
    .v-slider__thumb:before{
      top: -8px;
      left: -8px;
    }
    .theme--light.v-slider .v-slider__track-background{
      border-top-right-radius: 40px;
      border-bottom-right-radius: 40px;
    }
    .theme--light.v-slider .v-slider__thumb{
      border-radius: 40px;
    }
    .theme--light.v-slider .v-slider__track-fill{
      border-top-left-radius: 40px;
      border-bottom-left-radius: 40px;
    }
  }
  .diaryWriteText{

    &.v-text-field{
      padding: 0;
      margin: 0;
    }
    &.v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot{
      margin: 0;

      textarea{
        height: calc(100vh - 194px);
        padding: 16px 20px 40px;
        line-height: 1.4em;
        resize: none;

        &::placeholder{
          color: #555;
        }
      }
    }
    &.theme--light.v-text-field > .v-input__control > .v-input__slot:before{
      border-color: #ccc;
    }
  }
}
</style>